// Make token expires after 7 days
export const INVITATION_EXPIRATION_TIME_SEC = 60 * 60 * 24 * 7;
